import React, { useRef } from "react";



import {
  DateField,
  List,
  Show,

  SimpleShowLayout,
  TextField,

  NumberInput,
  Datagrid,
  SimpleFormIterator,
  ArrayInput,

  TopToolbar,
  useCreate, useNotify, ArrayField,
  useRefresh,
  useRedirect,
  SimpleForm,
  Edit,
  CreateButton,
  SelectInput,
  ImageField,
  FormDataConsumer,
  useGetOne,
  Loading,
} from "react-admin";
// import { useDownloadExcel } from 'react-export-table-to-excel';
import ReactHTMLTableToExcel from "react-html-table-to-excel";




import CreateView from "../../components/CreateView";
// import ShowView from "../../components/ShowView";




const CreateTemplateButton = ({ record }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [create, { isLoading }] = useCreate(
    'productCapacity',
    { isTemplate: true },
    {
      onSuccess: (data) => {
        console.log(data)
        // success side effects go here
        redirect('edit', 'productCapacity', data.data.id);

      },
      onError: (error) => {
        // failure side effects go here 
        notify(`خطا در ایجاد  : ${error.message}`, { type: 'warning' });
      },
    }
  );

  return <CreateButton label="ایجاد  " onClick={(e) => { e.preventDefault(); e.stopPropagation(); create() }} disabled={isLoading} />;
};

const ListActions = (props) => {

  return (
    <TopToolbar>
      {/* <CreateButton onClick={(e) => {e.preventDefault();e.stopPropagation();
       handleClick(); 
  }}
    /> */}
      <CreateTemplateButton />
    </TopToolbar>
  )
};



export const ProductCapacityList = (props) => {

  return (
    <List {...props} actions={<ListActions />}
      sort={{ field: 'updatedAt', order: 'DESC' }} >
      <Datagrid rowClick="show" >
        <TextField source="user.name" label="ساخته شده توسط" />
        <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="updatedAt" label=" بروزرسانی  " />
      </Datagrid>
    </List>
  )
};


export const ProductCapacityEdit = (props) => {

  const refresh = useRefresh();

  setTimeout(function () {
    refresh();
  }, 2000);


  // const handleTotalChange = (event, formData) => {
  //   let totalRemoteItems = event.target.value
  //   let id = formData?.productId?._id
  //   const index = weights.findIndex(weight => weight.id === id);
  //   if (index === -1) {
  //     // item does not exist in array, so add it
  //     setWeights([...weights, { id, totalRemoteItems }]);
  //   } else {
  //     // item exists, so update it
  //     const newWeights = [...weights];
  //     newWeights[index] = { ...newWeights[index], totalRemoteItems };
  //     setWeights(newWeights);
  //   }
  // }


  return (
    <Edit {...props} actions={null} >
      <SimpleForm variant="outlined" submitOnEnter={false}>
        <ArrayInput source="products" label="">
          <SimpleFormIterator className="grid grid-flow-row-dense grid-cols-1  grid-rows-1  border-spacing-6 border-cyan-400" disableRemove disableAdd disableReordering>

            <FormDataConsumer >
              {/* {({ formData, getSource, scopedFormData }) => { */}
              {({ formData, getSource, scopedFormData }) => {
                return (
                  <div
                    className="grid 2xl:grid-col-12 xl::grid-col-6  lg:grid-cols-6 md:grid-cols-3 sm: grid-cols-1 items-center  gap-2"
                  >
                    <ImageField record={scopedFormData} source={"productId.icon"} />
                    <TextField record={scopedFormData} className="pr-4" source="productId.title" />
                    {/* <ReferenceInput record={scopedFormData} variant="outlined" label="نوع بسته‌بندی" source={getSource("productPackages.productUnit")} reference="productUnit" >
                      <SelectInput optionText="title" style={{ width: '190px' }} />
                    </ReferenceInput> */}

                    <SelectInput
                      label="نوع بسته"
                      source={getSource("selectedPackage")}
                      variant="outlined"
                      optionText="title"
                      optionValue="_id"
                      record={scopedFormData}
                      choices={scopedFormData?.productId?.productPackages}
                      initialValue={scopedFormData?.productId?.productPackages[0]?._id}
                    />
                    <NumberInput source={getSource("capacity")}
                      label="مقدار"
                      min={0}
                      defaultValue={0}
                      // onBlur={(e) => {handleTotalChange(e, scopedFormData);}}
                      onWheel={e => e.target instanceof HTMLElement && e.target.blur()}
                      record={scopedFormData} variant="outlined"
                      locales={"fa"} style={{ position: 'relative', width: 90 }} />
                    {/* <div  >معادل {weights.find(x => x.id == scopedFormData?.productId._id)?.totalRemoteItems}</div> */}


                  </div>
                )
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit >
  )
};

// export const customAction = ({ record, props }) => {
//   console.log("inside action", record)
// }
// const PostShowActions = () => {
//   return <TopToolbar><Button label="ایجاد گزارش" onClick={customAction} /></TopToolbar>
// };

export const ProductCapacityShow = (props, { record }) => {
  const tableRef = useRef(null);
  //   const { onDownload } = useDownloadExcel({
  //     currentTableRef: tableRef.current,
  //     filename: 'Users table',
  //     sheet: 'Users'
  // })

  const { data: pc, isLoading, error } = useGetOne('productCapacity', props.id);

  if (isLoading) return <Loading />;
  if (error) return <div />;
  if (!pc) return null;  // record.prodcutId.productPackages


  return (<Show {...props} actions={null}>
    <SimpleShowLayout>
      <TextField source="user.name" label="ساخته شده توسط" />
      <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="updatedAt" label=" آخرین بروزرسانی " />
      <DateField options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="createdAt" label=" تاریخ ایجاد " />

      <ReactHTMLTableToExcel
        id="table-xls-button"
        className="download-table-xls-button"
        table="table-to-xls"
        filename="export-productCapacity"
        sheet="export"
        buttonText="دریافت فایل خروجی"
      />

      <ArrayField source="products" label=" " {...props}>
        <Datagrid id="table-to-xls" ref={tableRef}>
          <TextField source="productId.title" label="محصول" />
          <BoxType pc={pc} />
          <TextField label="ظرفیت" source="capacity" style={{ float: 'right', marginRight: '20px', marginLeft: '10px', width: '20%' }} />
        </Datagrid>
      </ArrayField>

    </SimpleShowLayout>
  </Show>
  )
};
const BoxType = ({ pc, record }) => {
  // const record = useRecordContext();

  // if (error) return <Error />;
  //selectedPackage
  //
  const type = pc.products.find(p => p.id === record.id)
  if (!type.productId?.productPackages) return null;
  let indexF = type.productId?.productPacfkages?.findIndex(x => x._id === record.selectedPackage)
  if (indexF < 0)
    indexF = 0;
  let pp = type.productId.productPackages[indexF]
  if (!pp) return null;
  return (
    <span>{pp.title}</span>
  )
}
export const ProductCapacityCreate = (props) => (
  <CreateView {...props}>
  </CreateView>
);
